export default __webpack_public_path__ + "static/media/D.86401af5.png";